import { render } from "./A102010.vue?vue&type=template&id=07a5bd42&scoped=true"
import script from "./A102010.vue?vue&type=script&lang=js"
export * from "./A102010.vue?vue&type=script&lang=js"

import "./A102010.vue?vue&type=style&index=0&id=07a5bd42&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a5bd42"]])

export default __exports__